import React from 'react';
import TextBox from '../../../element/textbox';
import Title from '../../../element/title';
import url from '../../../urlhandler/urlHandlerActions';

class TextBoxPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'options': [],
      'toogle': false,
    };
    this.changeToogle = this.changeToogle.bind(this);
    this.handleTextbox = this.handleTextbox.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.block = nextprops.block;
    this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  handleTextbox(values) {
    url.push({
      'searchItem': 'search_item',
      'searchType': 'globalSearch',
      'searchField': 'textbox',
      values,
    });
    this.setState({ values });
  }
  render() {
    const values = this.props.urlData.search_item;
    const textBoxClassName = this.props.block.dynamicNameClassTextBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';
    return (<div className={textBoxClassName}>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {'true'}
        dropdown={true}
        field={this.props.block.uid}
      />
      { this.state.toogle ? <div className={HelperClass + ' ' + 'dropdown-template'}><TextBox value={values} grabTextBoxValue={this.handleTextbox} /></div> : null }
    </div>);
  }
}

TextBoxPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default TextBoxPreview;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/search/dropdown/textboxdropdownpreview.js